import { getSubAccountMonitorMsg, saveSubAccountMonitorMsg } from "@/api/MonitorType";
const state = {
  getSubAccountMonitorMsg:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  getSubAccountMonitorMsg({ commit },data) { 
    return new Promise((resolve)=>{
      getSubAccountMonitorMsg(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'getSubAccountMonitorMsg',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
  
  saveSubAccountMonitorMsg({ commit },data) { 
    return new Promise((resolve)=>{
        saveSubAccountMonitorMsg(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'saveSubAccountMonitorMsg',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
